














































import ICustomer from '@/store/models/ICustomer';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Vue, Component, Watch } from 'vue-property-decorator';
import CustomerApi from '../store/api/CustomerApi';
import ListPhonePrefixesApi from '../store/api/ListPhonePrefixesApi';
import CustomerSelector from '@/components/selectors/Customer/CustomerSelector.vue';
import ICustomerAdresses from '@/store/models/ICustomerAdresses';
import IListCountries from '@/store/models/IListCountries';
import ListCountriesApi from '@/store/api/ListCountriesApi';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import ListAdressTypesApi from '@/store/api/ListAdressTypesApi';
import CustomerAdressesApi from '@/store/api/CustomerAdressesApi';
import ICustomerContacts from '@/store/models/ICustomerContacts';
import CustomerContactsApi from '@/store/api/CustomerContactsApi';
import ICompany from '@/store/models/ICompany';
import CompanyApi from '@/store/api/CompanyApi';
import IUser from '@/store/models/IUser';
import IRole from '@/store/models/IRole';
import RoleApi from '@/store/api/RoleApi';
import UserApi from '@/store/api/UserApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        CustomerSelector,
        Snackbar
    }
})
export default class Customers extends Vue {
    // CustomerSelector
    CustomerList : ICustomer[] = [];
    customerApi : CustomerApi;
    ListPhonePrefix : IListPhonePrefix[] = [];
    listPhonePrefixesApi : ListPhonePrefixesApi;
    phonePrefixCountry : string[] = [];
    selectedCustomer : ICustomer | null = null;
    idCustomer : string = "";
    ListCompany : ICompany[] = [];
    ListRole : IRole[] = [];
    companyApi : CompanyApi;
    roleApi: RoleApi;
    userApi: UserApi;
    // CustomerAdressesSelector
    CustomerAdressesList : ICustomerAdresses[] = [];
    customerAdressesApi : CustomerAdressesApi;
    ListCountries : IListCountries[] = [];
    listCountriesApi : ListCountriesApi;
    ListAdressTypes : IListAdressTypes[] = [];
    listAdressTypesApi : ListAdressTypesApi;
    countryName : string[] = [];
    adressTypeName : string[] = [];
    selectedCustomerAdres : ICustomer[] = [];

    // CustomerContactsSelector
    CustomerContactsList : ICustomerContacts[] = [];
    customerContactsApi : CustomerContactsApi;
    overlay: boolean = false;
    companyId : string = "";
    permissions : IRolePermission[] = [];
    companyLicensesApi: CompanyLicensesApi;
    hasLicenseScanner: boolean = false;
    settingsCompanyApi: SettingsCompanyApi;
    scannerActive : boolean = false;

    constructor() {
        super();
        this.customerApi = new CustomerApi();
        this.listPhonePrefixesApi = new ListPhonePrefixesApi();
        this.listCountriesApi = new ListCountriesApi();
        this.listAdressTypesApi = new ListAdressTypesApi();
        this.customerAdressesApi = new CustomerAdressesApi();
        this.customerContactsApi = new CustomerContactsApi();
        this.companyLicensesApi = new CompanyLicensesApi();
        this.roleApi = new RoleApi();
        this.companyApi = new CompanyApi();
        this.userApi = new UserApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Customers");
    }

    created() {
        this.getPermissions();
        this.getCustomers();
        this.getCompanies();
        this.getListPhonePrefixes();
        this.getCountries();
        this.getAdresTypes();
        this.getRoles();
    }

    customerChanged(customer: ICustomer) {
        if (customer !== undefined && Object.keys(customer).length !== 0) {
            this.getCustomerAdresses(this.selectedCustomer!.id);
            this.getCustomerContacts(this.selectedCustomer!.id);
        }
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Customers"));
        let settingsCompany = SettingsCompany.Settings.IdUserCanModifyInOutbounds;
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);
        this.hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        if (!this.hasLicenseScanner) {
            this.scannerActive = true;
            settingsCompany = SettingsCompany.Settings.Scanner;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomersByCompanyId(this.companyId);
    }

    async getRoles() {
        this.ListRole = await this.roleApi.GetRoles(this.companyId);
    }

    async getCompanies() {
        this.ListCompany = await this.companyApi.GetCompaniesById(this.companyId);
    }

    async getListPhonePrefixes() {
        this.ListPhonePrefix = await this.listPhonePrefixesApi.GetListPhonePrefixes();
        if (this.ListPhonePrefix) {
            this.phonePrefixCountry = this.ListPhonePrefix.map(l => l.country);
        }
    }

    deleteCustomer (item: ICustomer) {
        confirm('Are you sure you want to delete this customer?') && this.deleteCustomerItem(item);
    }

    async deleteCustomerItem(customer: ICustomer) {
        this.overlay = true;
        let result: boolean = await this.customerApi.DeleteCustomer(customer.id);
        result = await this.userApi.DeleteUser(customer.userName);
        if (result) {
            const index = this.CustomerList.indexOf(customer);
            this.CustomerList.splice(index, 1);
            this.showMessageInfo(`The customer ${customer.name} has been successfully deleted`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCustomer (customer: ICustomer) {
        this.overlay = true;
        if (!customer.id) {
            customer.idCompany = this.companyId;
            let company = this.ListCompany.find(c => c.id === this.companyId)as ICompany;
            customer.companyName = company.name;
            customer.idUser = EMPTY_GUID;
            const id = await this.customerApi.SaveCustomer(customer);
            if (id) {
                customer.id = id;
                this.CustomerList = [customer].concat(this.CustomerList);
                this.selectedCustomer = customer;
                this.showMessageInfo(`The customer ${customer.name} has been successfully saved`);
            } else {
                const errors: string = this.customerApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        } else {
            const errors: string = this.userApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editCustomer (editedCustomer: ICustomer) {
        this.overlay = true;
        // const user : IUser = {} as IUser;
        // user.userName = "ssi";
        // user.password = "whs@bd24!";
        // user.idRole = "0CDBD438-C630-441F-AF70-D042BE10E77E";
        // const idUser = await this.userApi.CreateUser(user);
        // editedCustomer.idUser = idUser;
        let result : boolean = await this.customerApi.UpdateCustomer(editedCustomer);
        if (result) {
            this.showMessageInfo(`The customer ${editedCustomer.name} has been successfully edited`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
 
    async getCountries() {
        if (this.ListCountries.length === 0) {
            this.ListCountries = await this.listCountriesApi.GetListCountries();
            if (this.ListCountries) {
                this.countryName = this.ListCountries.map(l => l.countryName);
            }
        }
    }

    async getAdresTypes() {
        if (this.ListAdressTypes.length === 0) {
            this.ListAdressTypes = await this.listAdressTypesApi.GetListAdressesTypes();
            if (this.ListAdressTypes) {
                this.adressTypeName = this.ListAdressTypes.map(l => l.typeName);
            }
        }
    }

    async getCustomerAdresses(customerId: string) {
        this.CustomerAdressesList = await this.customerAdressesApi.GetCustomerAdresses(customerId);
    }

    deleteCustomerAdress (item: ICustomerAdresses) {
        confirm('Are you sure you want to delete this customer Adres?') && this.deleteCustomerAdressItem(item);
    }

    async deleteCustomerAdressItem(customerAdres: ICustomerAdresses) {
        this.overlay = true;
        let result: boolean = await this.customerAdressesApi.DeleteCustomerAdres(customerAdres.id);
        if (result) {
            const index = this.CustomerAdressesList.indexOf(customerAdres);
            this.CustomerAdressesList.splice(index, 1);
            this.showMessageInfo(`The customer adress has been successfully deleted`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCustomerAdress (editedCustomerAdres: ICustomerAdresses) {
        this.overlay = true;
        editedCustomerAdres.idCustomer = this.selectedCustomer!.id;
        const customerAdresId = await this.customerAdressesApi.SaveCustomerAdres(editedCustomerAdres);
        if (customerAdresId) {
            editedCustomerAdres.id = customerAdresId;
            this.CustomerAdressesList = [editedCustomerAdres].concat(this.CustomerAdressesList);
            this.showMessageInfo(`The customer adress has been successfully saved`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editCustomerAdress (editedCustomerAdres: ICustomerAdresses) {
        this.overlay = true;
        let result : boolean = await this.customerAdressesApi.UpdateCustomerAdres(editedCustomerAdres);
        if (result) {
            this.showMessageInfo(`The customer adres has been successfully edited`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getCustomerContacts(customerId: string) {
        this.CustomerContactsList = await this.customerContactsApi.GetCustomerContacts(customerId);
    }

    deleteCustomerContact (item: ICustomerContacts) {
        confirm('Are you sure you want to delete this customer Contact?') && this.deleteCustomerContactItem(item);
    }

    async deleteCustomerContactItem(customerContact: ICustomerContacts) {
        this.overlay = true;
        let result: boolean = await this.customerContactsApi.DeleteCustomerContact(customerContact.id);
        if (result) {
            const index = this.CustomerContactsList.indexOf(customerContact);
            this.CustomerContactsList.splice(index, 1);
            this.showMessageInfo(`The customer contact has been successfully deleted`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCustomerContact (customerContact: ICustomerContacts) {
        this.overlay = true;
        customerContact.idCustomer = this.selectedCustomer!.id;
        const customerContactId = await this.customerContactsApi.SaveCustomerContact(customerContact);
        if (customerContactId) {
            customerContact.id = customerContactId;
            this.CustomerContactsList = [customerContact].concat(this.CustomerContactsList);
            this.showMessageInfo(`The customer contact has been successfully saved`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editCustomerContact (editedCustomerContact: ICustomerContacts) {
        this.overlay = true;
        let result : boolean = await this.customerContactsApi.UpdateCustomerContact(editedCustomerContact);
        if (result) {
            this.showMessageInfo(`The customer contact has been successfully edited`);
        } else {
            const errors: string = this.customerApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetCustomer() {
        this.CustomerContactsList = [];
        this.CustomerAdressesList = [];
        this.selectedCustomer = null;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
